import { ITermsResponse } from "@literax/models/terms.model";

export interface ITermsState {
  terms_of_service: ITermsResponse
}
  
export const initialTermsState: ITermsState = {
  terms_of_service: null
};
